import groupArrayByValue from '@src/functions/groupArrayByValue';
// import custom components
import { addToCart, addToCompare, addToWishlist, sortProductCollection } from '@src/redux/actions';
import parsePhoneNumber from 'libphonenumber-js';
import { findPhoneNumbersInText } from 'libphonenumber-js';
import uniqBy from 'lodash/uniqBy';
import Image from 'next/image';
import Link from 'next/link';
import React, { Component } from 'react';
import toast from 'react-hot-toast';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import SimpleReactValidator from 'simple-react-validator';
import Product from './product';

const customStyles = {
	singleValue: (provided, state) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = 'opacity 300ms';

		return { provided, opacity, transition };
	},

	control: provided => ({
		...provided,
		// padding: '0.5rem',
		border: '2px solid #eff8fc',
	}),

	menu: provided => ({
		...provided,
		position: 'static',
	}),

	input: provided => ({
		...provided,
		height: '0px',
	}),

	// FIXME: Duplicate value (V.T. 21.12.2021.)
	// singleValue: provided => ({
	// 	...provided,
	// 	color: '#0b7a9a',
	// }),


	placeholder: provided => ({
		...provided,
		color: '#0b7a9a',
	}),

	menuList: provided => ({
		...provided,
		maxHeight: '1000px !important',
	}),
};

const formatCurrency = require('format-currency');

class ProductListing extends Component {
	constructor(props) {
		super(props);

		this.state = {
			limit: 25,
			hasMoreItems: true,
			productListingGroupsMeta: [],
			productListingGroups: [],
			forceState: false,
			preferenceModalOpen: true,
			needHelp: true,
			retrievingType: null,
			productLevelType: null,
			size: 0,
		};
		this.validator = new SimpleReactValidator({
			locale: 'en',
			autoForceUpdate: this,
		});
		this.submitFilter = this.submitFilter.bind(this);
	}

	fetchMoreItems() {
		// console.log("Do Nothing Yet..");
	}

	onOpenModal = () => {
		this.setState({ preferenceModalOpen: true });
	};

	onCloseModal = () => {
		this.setState({ preferenceModalOpen: false });
	};

	async componentDidMount() {
		const hasLabor = this.props.productServices.find(element => element.hasLabor == true) ? true : false;
		this.setState({ needHelp: hasLabor });
		await this.updateProductList();
		if (typeof window !== 'undefined') {
			this.setState({ size: window.innerWidth });
		}
	}

	submitFilter() {
    if (this.validator.allValid()) {
      var phoneNumber = this.props.masterProvider.isActive ? this.props.masterProvider.phoneNumber : '1-800-228-8379';
      var googleNumber = findPhoneNumbersInText(phoneNumber, 'US');
      if (googleNumber.length > 0) {
        googleNumber = parsePhoneNumber(googleNumber[0].number.number);
        phoneNumber = googleNumber.formatNational();
        googleNumber = googleNumber.getURI();
      }
      if (this.state.retrievingType == 'call') {
        // FIXME: use a tag "phone: " attribute (V.T. 11.2.2022)
        if (typeof window !== 'undefined') {
          window.open({ phoneNumber });
        }
        return;
      }
      if (this.state.retrievingType == null) {
        toast.info('Please Select How you would like to receive item..');
        return;
      }
  
      const selectedServices = this.props.productServices.find(
        element => element.ButtonGrouping == this.state.retrievingType
      );
  
      this.props.sortProductCollection(this.props.productList, selectedServices, this.state.productLevelType);
      this.setState({ preferenceModalOpen: false });
    }

    else {
      this.validator.showMessages();
			this.forceUpdate();
			return false;
    }
		
	}

	updateProductList() {
		const availableSortSequences = uniqBy(this.props.productList, 'serviceSortSequence');
		const grouped = groupArrayByValue(this.props.productList, type => type.serviceSortSequence);

		var groups = [];
		var products = [];
		availableSortSequences.map((item, index) => {
			groups.push({
				id: item.serviceSortSequence,
				title: item.serviceGroupMessage,
			});

			products.push(grouped.get(item.serviceSortSequence));
		});

		this.setState({
			productListingGroupsMeta: groups,
			productListingGroups: products,
		});

		var trackProducts = [];
		this.props.productList.map((prod, index) => {
			trackProducts.push({
				product_id: prod.bigCommerceId,
				sku: prod.sku,
				name: prod.name,
				price: prod.price,
				position: index,
				category: prod.categoryId,
				brand: prod.brandId,
			});
		});

		analytics.track('Product List Viewed', {
			category: this.props.applicationLabel,
			products: trackProducts,
		});
	}

	async componentDidUpdate(prevProps) {
		if (prevProps.productList !== this.props.productList) {
			await this.updateProductList();
		}
	}

	// FIXME: Hack for forcing state to re-render when provider changed.
	forceState = () => {
		this.setState({ forceState: !this.state.forceState });
	};

	render() {
		const multibutton = this.state.size >= 768 ? true : false;
    const validator = this.validator;
		const {
			productList,
			addToCart,
			addToWishlist,
			addToCompare,
			applicationSlug,
			applicationLabel,
			provider,
			productServices,
			category,
			reviews,
		} = this.props;

		const { productListingGroupsMeta, productListingGroups, needHelp, retrievingType } = this.state;

		const hasLabor = productServices.find(element => element.hasLabor == true) ? true : false;
		if (category && category && category.id == 2) {
			// FIXME: this is not used anywhere => isAutomotive = true;
		}

		const productLevel = productList.filter(
			product =>
				product.productServiceButtons.some(service => service.ButtonGrouping == retrievingType) &&
				product.groupMessage != null &&
				product.groupMessage != ''
		);
		var levels = productLevel
			.map(item => item.groupMessage)
			.filter((value, index, self) => self.indexOf(value) === index);
		var serviceLevels = [];
		let levelsOptions = [];
		levels.forEach(level => {
			var prod = productList.filter(
				product =>
					product.productServiceButtons.some(service => service.ButtonGrouping == retrievingType) &&
					product.groupMessage == level &&
					product.groupMessage != ''
			)[0];
			serviceLevels.push({
				level: level,
				price: prod.price,
				warranty: prod.warranty,
				callForPrice: prod.callForPrice,
			});
		});

		for (let i = 0; i < levels.length; i++) {
			levelsOptions.push({
				label: (
					<div className="complex-selection">
						<span
							className="indicator"
							style={{
								color:
									levels[i] === 'Ultimate'
										? '#26A134'
										: levels[i] === 'Best'
										? '#BCCF2B'
										: levels[i] === 'Better'
										? '#EADE22'
										: levels[i] === 'Good'
										? '#DDAE32'
										: levels[i] === 'Lowest'
										? '#BA7338'
										: '#BA7338',
							}}>
							<i className="fas fa-circle"></i>
						</span>
						<span className="text">
							<span className="main">
								<b>{levels[i]}</b> Price and Performance
							</span>
							<span className="description">
								{serviceLevels[i].callForPrice
									? `Please Call for Price`
									: `Starting at: $${formatCurrency(serviceLevels[i].price)}`}
							</span>

							{serviceLevels[i].warranty && (
								<span className="description">{`Warranty: ${serviceLevels[i].warranty}`}</span>
							)}
						</span>
					</div>
				),
				value: levels[i],
			});
		}

		return (
			<div>
				{productListingGroupsMeta.length > 1 && (
					<div className="category-section-selection">
						{multibutton ? <h5>Service:</h5> : ''}
						<div>
							<a
								key="help"
								className="btn"
								href={`#help`}
								onClick={() => this.setState({ preferenceModalOpen: true })}>
								<i className="fad fa-question-circle" aria-hidden="true"></i>{' '}
								{multibutton ? 'Help Me Decide' : 'Click Here for Item Selection Help'}
							</a>
						</div>
						{multibutton
							? productListingGroupsMeta.map(item => (
									<a key={item.title} className="btn" href={`#${item.title}`}>
										<i className="fas fa-bars" aria-hidden="true"></i> {item.title}
									</a>
							  ))
							: ''}
					</div>
				)}

				<div className="product-wrapper-grid">
					{productServices.length > 1 ? (
						<Modal
							classNames={{
								modal: `change-location-modal preference-question-modal`,
							}}
							open={this.state.preferenceModalOpen}
							onClose={this.onCloseModal}>
							<div className="location-items-integrated preference-question-modal-inner">
								<div className="header">
									<div className="info mb-0">
										<h3>
											<i className="far fa-info-circle"></i> Personalize the Selection
										</h3>
										<div className="button-container">
											<button
												className="btn"
												onClick={() => this.setState({ preferenceModalOpen: false })}>
												<i className="fas fa-times" aria-hidden="true"></i>
												Cancel
											</button>
										</div>
									</div>
								</div>

								<div className="body">
									{hasLabor && (
										<div id="installhelp" className={`item p-0 mb-3`}>
											<h3>Do you need help installing?</h3>
											<div className="btn-group">
												<button
													id="help"
													className={`btn ${needHelp ? 'selected' : ''}`}
													onClick={() =>
														this.setState({
															needHelp: true,
															retrievingType: null,
															productLevelType: null,
														})
													}>
													<div className="icon">
														{needHelp ? (
															<i className="fas fa-check-circle"></i>
														) : (
															<i className="far fa-circle"></i>
														)}
													</div>

													<div className="text">
														<span className="main-text">Yes, I&apos;ll need help</span>
														<span className="help-text">
															Recommended - Using our Certified Installers.
														</span>
														<span className="help-text">{`${
															category && category.id == 2
																? `on your ${category.applicationLabel}`
																: ''
														}`}</span>
														<span className="help-text">
															{category && category.id == 2
																? `Your vehicle may require a computer reset.`
																: ''}
														</span>
													</div>
												</button>

												<button
													id="dify"
													className={`btn ${needHelp === false ? 'selected' : ''}`}
													onClick={() =>
														this.setState({
															needHelp: false,
															retrievingType: null,
															productLevelType: null,
														})
													}>
													<div className="icon">
														{needHelp === false ? (
															<i className="fas fa-check-circle"></i>
														) : (
															<i className="far fa-circle"></i>
														)}
													</div>
													<div className="text">
														<span className="main-text">No, I&apos;ll do it on my own</span>
													</div>
												</button>
											</div>
										</div>
									)}

									<div id="serviceselect" className={`item p-0 mb-3`}>
										<h3>Please select how to get the item?</h3>
										<div className="btn-group">
											{productServices
												.filter(element => element.hasLabor == needHelp)
												.map((item, index) => (
													<button
														key={index}
														className={`btn ${
															retrievingType === item.ButtonGrouping ? 'selected' : ''
														}`}
														onClick={() =>
															this.setState({ retrievingType: item.ButtonGrouping })
														}>
														{retrievingType === item.ButtonGrouping ? (
															<div className="icon">
																<i className="fas fa-check-circle"></i>
															</div>
														) : (
															<div className="icon">
																<i className="far fa-circle"></i>
															</div>
														)}
														{item.ButtonGrouping}
													</button>
												))}
											{productServices.filter(element => element.hasLabor == needHelp).length ==
											0 ? (
												<div id="unavailable" className="btn">
													Service is unavailable in your area.
												</div>
											) : (
												<div className="mt-2">
                          {validator.message('selection', this.state.retrievingType, 'required')}
                        </div>
											)}
										</div>

                    
									</div>

									{retrievingType && levels.length > 1 && (
										<div id="productlevelselect" className={`item p-0 mb-3`}>
											<h3>Select your Value Level?</h3>
											<Select
							
												options={levelsOptions.reverse()}
												styles={customStyles}
												onChange={value => {
													this.setState({ productLevelType: value.value });
												}}
												isSearchable={false}
											/>

                      <div className="mt-3">
                        {validator.message('Value Level', this.state.productLevelType, 'required')}
                      </div>
										</div>
									)}

									<div className="footer">
										<div className="text-center">
											<button
												id="submit"
												className="block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 bg-[#0ebcee] text-white shadow-sm hover:bg-[#0889ad]  w-100 border-none"
												type="button"
												onClick={() => this.submitFilter()}>
												Submit
											</button>
										</div>
									</div>
								</div>
							</div>
						</Modal>
					) : (
						''
					)}
					{productList.length > 0 ? (
						<>
							<InfiniteScroll
								dataLength={this.state.limit}
								next={this.fetchMoreItems}
								hasMore={this.state.hasMoreItems}
								endMessage={
									<p className="seen-cls seen-it-cls">
										<b>List Completed</b>
									</p>
								}>
								{productListingGroupsMeta.map((item, index) => (
									<div className="category-section" key={index} id={item.title}>
										<div className="section-header">
											<h2>
												{item.title}
												{item.id >= 100 &&
													item.id <= 199 && ( // id refers to MOBILE DELIVERY OR SERVICE
														<>
															<span className="subtitle">
																We come to your location and do the delivery, testing,
																and installation.
															</span>
														</>
													)}
											</h2>
										</div>

										<div className="mx-auto">
												<div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-1 lg:grid-cols-3 lg:gap-x-8">
												{productListingGroups[index].map((item, i) => {
													item.applicationLabel = category.applicationLabel.trim();
													return (
														<Product
															reviews={reviews}
															cartlist={this.props.cartlist}
															key={i}
															index={i}
															product={item}
															symbol="$"
															onAddToWishlistClicked={() => addToWishlist(item)}
															onAddToCompareClicked={() => addToCompare(item)}
															onAddToCartClicked={() => addToCart(item, 1)}
															applicationSlug={applicationSlug}
															applicationLabel={applicationLabel}
															provider={provider}
															externalrequest={this.props.externalrequest}
															setSelectedProvider={this.props.setSelectedProvider}
															showBuyButton={this.props.showBuyButton}
															isUpdating={this.props.isUpdating}
															forceState={this.forceState}
														/>
													);
												})}
												</div>
											</div>
									</div>
								))}
							</InfiniteScroll>
						</>
					) : (
						<div className="row">
							<div className="col-sm-12 text-center section-b-space mt-5 no-found">
								<Image
									src={`../../static/images/empty-search.jpg`}
									className="img-fluid mb-4 lazyload"
									alt=""
								/>
								<h3>Loading... </h3>
								<p>Please call us if you have any questions.</p>

								<Link href={`/`} as={`/`}>
									<a className="btn success">Continue Shopping</a>
								</Link>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}
const mapStateToProps = state => ({
	provider: state.provider,
	category: state.category,
	cartlist: state.cartlist,
});

export default connect(mapStateToProps, {
	addToCart,
	addToWishlist,
	addToCompare,
	sortProductCollection,
})(ProductListing);
